import { render, staticRenderFns } from "./ProjectListingSN2.vue?vue&type=template&id=23993ec0"
import script from "./ProjectListingSN2.vue?vue&type=script&lang=js"
export * from "./ProjectListingSN2.vue?vue&type=script&lang=js"
import style0 from "./ProjectListingSN2.vue?vue&type=style&index=0&id=23993ec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports